import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: 'Immediatamente dopo il pagamento ricevi un link per scaricare tutti i PDF. Accesso immediato, nessuna attesa. Puoi usare i materiali già dalla prossima lezione.'
}, {
  q: 'Funziona sia per il Biennio che per il Triennio?',
  a: 'Sì. I Tomi 1-2 coprono il Biennio (fondamenti contabili e IVA), i Tomi 3-6 il Triennio e la preparazione alla Maturità. Ogni sezione indica chiaramente il livello target.'
}, {
  q: 'Cosa succede se ho studenti con BES o DSA?',
  a: "Il Bonus 1 è interamente dedicato all'inclusione con materiali compensatori, mappe concettuali e PDP template pronti. Ogni tomo include attività differenziate per livello — Legge 170/2010 finalmente senza stress."
}, {
  q: 'È allineato ai programmi del MIM?',
  a: "Sì. Tutti i contenuti seguono le Indicazioni Nazionali per gli ITE, il PECUP, le linee guida per l'Educazione Civica e i quadri di riferimento ministeriali per l'Esame di Stato 2025-2026."
}, {
  q: 'I materiali sono editabili?',
  a: "Sì. Ricevi i file pronti da personalizzare con i dati della tua classe, il tuo nome e l'intestazione della tua scuola. Modifichi solo ciò che ti serve, il resto è già fatto."
}, {
  q: 'Per quanto tempo ho accesso?',
  a: "A vita. Paghi una volta sola e i materiali sono tuoi per sempre, inclusi tutti gli aggiornamenti futuri (normativa fiscale, quadri ministeriali, nuove tracce d'esame)."
}, {
  q: 'Excel Automatico funziona davvero senza conoscenze tecniche?',
  a: 'Sì. I fogli del Bonus 2 sono pre-impostati: inserisci i dati nelle celle gialle, il file calcola, valuta e produce il voto in automatico. Funziona con Excel, Google Sheets e LibreOffice.'
}, {
  q: 'Le griglie sono compatibili con il mio registro elettronico?',
  a: 'Sì. Le griglie del Bonus 4 sono pronte per ClasseViva, Argo e Axios. Copi e incolli i descrittori, oppure usi direttamente i punteggi numerici già calibrati sul DM ministeriale.'
}, {
  q: 'Posso chiedere un rimborso se non sono soddisfatto?',
  a: "Sì. Hai 14 giorni di garanzia 'Classe Soddisfatta'. Se non hai recuperato almeno 5 ore nella prima settimana, scrivi a kitonline27@gmail.com e ti rimborsiamo ogni centesimo. Senza domande."
}, {
  q: 'Il pagamento è sicuro? Ci sono costi nascosti?',
  a: 'Pagamento unico di €19,90 tramite circuito sicuro Shopify. Nessun abbonamento, nessun rinnovo automatico, nessun costo nascosto. Paghi una volta, accedi a vita.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-dark" data-id="element-87">
      <div className="max-w-3xl mx-auto" data-id="element-88">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-12 uppercase text-brand-cream" data-id="element-89">
          Domande Frequenti
        </motion.h2>

        <div className="space-y-4" data-id="element-90">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" data-id="element-91">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-white/5 transition-colors" data-id="element-92">
                <span className="font-bold text-brand-cream pr-4" data-id="element-93">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-orange transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-94" />
              </button>

              <AnimatePresence data-id="element-95">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-96">
                    <div className="px-6 pb-5 pt-0 text-gray-400 font-medium leading-relaxed" data-id="element-97">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}